import { Field } from '../field'
import { useFormFieldContext } from './form-context'

export default function FormFieldLabel(props: Field.Label.Props) {
  const field = useFormFieldContext()
  return <Field.Label htmlFor={field.name} {...props} />
}
